var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"main-privacy-heading"},[_vm._v("\n    Contact Us\n  ")]),_vm._v(" "),_c('div',{attrs:{"id":"hubspot-form"}})])
}]

export { render, staticRenderFns }